<template>
  <div class="orders-container">
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />

    <div class="d-flex align-center justify-space-between mb-8">
      <div class="d-flex align-center">
        <v-icon color="#3EA56E" class="mr-3">mdi-package-variant-closed</v-icon>
        <h2 class="section-title">My Orders</h2>
      </div>
      <v-btn
        v-if="products && products.length > 0"
        outlined
        color="#3EA56E"
        class="view-all-btn px-6 text-none"
        @click="$router.push('/orders?type=Active')"
      >
        View Detailed History
      </v-btn>
    </div>

    <div v-if="products && products.length > 0">
      <v-card flat class="orders-card overflow-hidden">
        <v-expansion-panels flat tile>
          <v-expansion-panel v-for="(item, i) in products" :key="i" class="order-panel">
            <v-expansion-panel-header class="order-header py-4">
              <v-layout wrap align-center>
                <v-flex xs12 sm6 class="text-left mb-2 mb-sm-0">
                  <div class="d-flex align-center">
                    <v-icon size="18" color="#64748b" class="mr-2">mdi-identifier</v-icon>
                    <span class="order-id">Order #{{ item.orderid.orderID }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="text-sm-right">
                  <div class="d-flex align-center justify-sm-end">
                    <v-icon size="16" color="#94a3b8" class="mr-2">mdi-calendar-range</v-icon>
                    <span class="order-date">{{ formatDate(item.date) }}</span>
                  </div>
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            
            <v-expansion-panel-content class="order-content">
              <v-divider></v-divider>
              <div v-for="(item1, j) in item.items" :key="j" class="order-item-row py-6">
                <v-layout wrap align-center>
 <v-flex xs4 sm3 md2>
  <v-card outlined class="product-img-card pa-2">
    <!-- Product image -->
    <v-img
      v-if="item1.productId?.photos && item1.productId.photos[0]"
      :src="mediaURL + item1.productId.photos[0]"
      height="100px"
      contain
    >
      <template v-slot:placeholder>
        <div class="img-shimmer"></div>
      </template>
    </v-img>

    <!-- No image fallback -->
    <v-img
      v-else
      src="@/assets/Images/noimage.png"
      height="100px"
      contain
    >
      <template v-slot:placeholder>
        <div class="img-shimmer"></div>
      </template>
    </v-img>
  </v-card>
</v-flex>
                  <v-flex xs8 sm9 md10 class="pl-4 pl-md-8">
                    <h3 class="product-name mb-1">{{ item1.productname }}</h3>
                    <div class="d-flex flex-wrap align-center">
                      <div class="info-tag mr-4 mb-1">
                        <span class="label">Price:</span>
                        <span class="value font-weight-bold">₹{{ item1.TotalAmount }}</span>
                      </div>
                      <div class="info-tag mr-4 mb-1">
                        <span class="label">Quantity:</span>
                        <span class="value">{{ item1.quantity }} {{ item1.productId.unit }}</span>
                      </div>
                      <div class="status-chip mb-1">
                        <v-chip
                          x-small
                          :color="getStatusColor(item1.orderStatus)"
                          dark
                          label
                          class="font-weight-bold"
                        >
                          {{ item1.orderStatus }}
                        </v-chip>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </div>

    <div v-else-if="!appLoading" class="text-center py-12">
      <v-icon size="64" color="#e2e8f0" class="mb-4">mdi-package-variant</v-icon>
      <p class="empty-text">You haven't placed any orders yet.</p>
      <v-btn color="#3EA56E" dark depressed to="/Products" class="mt-6 px-8 text-none font-weight-bold rounded-lg">
        Start Shopping
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      ServerError: false,
    };
  },
  beforeMount() {
    this.setMetaTags();
    this.getData();
  },
  methods: {
    setMetaTags() {
      document.title = "My Orders | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "View and manage your recent orders, track shipments, and check delivery status at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/my/orders/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error("Error fetching orders:", err);
        });
    },
    getStatusColor(status) {
      if (!status) return "#94a3b8";
      const s = status.toLowerCase();
      if (s.includes("deliver")) return "#3EA56E";
      if (s.includes("cancel")) return "#ef4444";
      if (s.includes("pend")) return "#f59e0b";
      return "#3b82f6";
    },
    formatDate(item) {
      if (!item) return "";
      const dt = new Date(item);
      const day = dt.getDate();
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = months[dt.getMonth()];
      const year = dt.getFullYear();
      let hours = dt.getHours();
      let minutes = dt.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
    },
  },
};
</script>

<style scoped>
.orders-container {
  text-align: left;
}

.section-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
  margin: 0;
}

.view-all-btn {
  border-radius: 8px;
  font-family: "ibmsemibold", sans-serif;
  font-size: 14px;
}

.orders-card {
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px;
}

.order-panel {
  border-bottom: 1px solid #f1f5f9;
}

.order-header {
  background-color: #ffffff;
  transition: background-color 0.2s ease;
}

.order-header:hover {
  background-color: #f8fafc;
}

.order-id {
  font-family: "ibmsemibold", sans-serif;
  font-size: 15px;
  color: #1e293b;
}

.order-date {
  font-family: "sofialight", sans-serif;
  font-size: 14px;
  color: #64748b;
}

.order-content {
  background-color: #fcfdfe;
}

.order-item-row {
  border-bottom: 1px dashed #e2e8f0;
}

.order-item-row:last-child {
  border-bottom: none;
}

.product-img-card {
  border-radius: 8px;
  border: 1px solid #f1f5f9 !important;
}

.product-name {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  color: #1a202c;
}

.info-tag .label {
  font-family: "sofialight", sans-serif;
  font-size: 13px;
  color: #94a3b8;
  margin-right: 4px;
}

.info-tag .value {
  font-family: "ibmregular", sans-serif;
  font-size: 14px;
  color: #334155;
}

.empty-text {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 18px;
  }
}
</style>
<style scoped>
.styl {
  /* overflow: scroll; */
  overflow-y: auto;
  min-height: 100px;
  max-height: 250px;
}
::-webkit-scrollbar {
  width: 5px !important;
  height: 1px !important;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px grey !important;
  border-radius: 5px !important;
}
::-webkit-scrollbar-thumb {
  background: #3ea56e !important;
  border-radius: 5px !important;
}
</style>
